// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanReactivationDto
 */
export interface IPlanReactivationDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof IPlanReactivationDto
     */
    plan_ids: Set<number>;
}

/**
 * Check if a given object implements the IPlanReactivationDto interface.
 */
export function instanceOfIPlanReactivationDto(value: object): value is IPlanReactivationDto {
    if (!('plan_ids' in value) || value['plan_ids'] === undefined) return false;
    return true;
}

export function IPlanReactivationDtoFromJSON(json: any): IPlanReactivationDto {
    return IPlanReactivationDtoFromJSONTyped(json, false);
}

export function IPlanReactivationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanReactivationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_ids': new Set(json['planIds']),
    };
}

export function IPlanReactivationDtoToJSON(json: any): IPlanReactivationDto {
    return IPlanReactivationDtoToJSONTyped(json, false);
}

export function IPlanReactivationDtoToJSONTyped(value?: IPlanReactivationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planIds': Array.from(value['plan_ids'] as Set<any>),
    };
}

